import formatVariantPrice from "../../lib/format-variant-price";
import * as currencyService from "@services/format/currency";

export function resolveTotalPrice(sections, discountMessage, state, currency) {
  const items = sections.map((section) => {
    if (state[`${section.key}-variant`]) {
      let { amount, compareAtAmount } = formatVariantPrice(
        state[`${section.key}-variant`],
        currency
      );

      if (discountMessage) {
        const discount = discountMessage.match(/\d+(\%)/g);
        if (discount) {
          if (!compareAtAmount) {
            compareAtAmount = amount;
          }
          const discountAmount = (amount * parseFloat(discount[0])) / 100.0;
          amount = amount - discountAmount;
        }
      }
      return {
        amount: amount,
        compareAtAmount: compareAtAmount,
      };
    }
    return {
      amount: 0,
      compareAtAmount: 0,
    };
  });

  const totalPrice = currencyService.formatPrice(
    items.reduce((previousValue, currentValue) => previousValue + currentValue.amount, 0),

    currency
  );
  const totalCompareAtAmount = items.reduce(
    (previousValue, currentValue) => previousValue + currentValue.compareAtAmount,
    0
  );
  let totalCompareAtPrice = null;
  if (totalCompareAtAmount > 0) {
    totalCompareAtPrice = currencyService.formatPrice(totalCompareAtAmount, currency);
  }

  return { totalPrice, totalCompareAtPrice };
}
